(function () {
  'use strict';

  var rules = [
    { pattern: /1\s*[–—-]\s*2\s*viikkoa/gi, replacement: '2–3 viikkoa' },
    { pattern: /1\s*[–—-]\s*2\s*viikon/gi, replacement: '2–3 viikon' },
    { pattern: /1\s*[–—-]\s*2\s*vk\.?/gi, replacement: '2–3 viikkoa' },
    { pattern: /1\s*[–—-]\s*2\s*vko\.?/gi, replacement: '2–3 viikkoa' },
    { pattern: /\b2\s*viikkoa\b/gi, replacement: '2–3 viikkoa' },
    { pattern: /\b2\s*viikon\b/gi, replacement: '2–3 viikon' },
    { pattern: /\b2\s*vk\.?\b/gi, replacement: '2–3 viikkoa' },
    { pattern: /\b2\s*vko\.?\b/gi, replacement: '2–3 viikkoa' }
  ];

  function replaceDeliveryText(value) {
    if (!value || typeof value !== 'string') return value;

    var next = value;
    rules.forEach(function (rule) {
      next = next.replace(rule.pattern, rule.replacement);
    });
    return next;
  }

  function shouldSkipNode(node) {
    if (!node || !node.parentNode) return true;
    var parent = node.parentNode;
    var tag = parent.nodeName ? parent.nodeName.toLowerCase() : '';
    return tag === 'script' || tag === 'style' || tag === 'textarea' || tag === 'input' || tag === 'select';
  }

  function updateTextNode(node) {
    if (shouldSkipNode(node)) return;
    var current = node.nodeValue;
    var next = replaceDeliveryText(current);
    if (next !== current) node.nodeValue = next;
  }

  function scan(root) {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      updateTextNode(root);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
      return;
    }

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return shouldSkipNode(node) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });

    var node;
    while ((node = walker.nextNode())) {
      updateTextNode(node);
    }
  }

  function init() {
    scan(document.body);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') {
          updateTextNode(mutation.target);
          return;
        }

        mutation.addedNodes.forEach(function (node) {
          scan(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
